import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Promo = Loadable(lazy(() => import('./promo')));

const promoRoutes = [
  { path: '/dashboard/promo', element: <Promo />, auth: authRoles.admin },
];

export default promoRoutes;
